import React, { useMemo } from 'react';
import VideoTranscript from '../../components/videoTranscript';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video1600');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video1600')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video1600')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video1600')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#video1600')
        ?.removeEventListener('play', onPlay);
  }, []);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <div className="title">
            <i className="title_icon" />
            <div className="message-box">
              <span>{paragraphsSettings?.message}</span>
              <span>{paragraphsSettings?.message1}</span>
            </div>
          </div>
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.description,
            }}
          />
          <div className="video-box">
            <div className="video-container">
              <video
                id="video1600"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
              <div className="flower"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="back-icon person"></div>
      <div className="back-icon background"></div>
    </div>
  );
};

export default Section0;
